import React from 'react';
import { brandColors } from '@giveth/ui-design-system';

const ArcWithDot = ({
	color = brandColors.mustard[500],
}: {
	color?: string;
}) => {
	return (
		<svg
			width='64'
			height='56'
			viewBox='0 0 64 56'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fill-rule='evenodd'
				clip-rule='evenodd'
				d='M5.79364 16.4736L6.73391 15.033L6.99019 14.7187L6.99232 14.7175C7.22102 14.4355 7.4678 14.1192 7.72945 13.7845C8.35995 12.9764 9.0723 12.0637 9.80886 11.2746C14.8174 5.89196 21.474 2.31395 28.7254 1.10676C35.9767 -0.100422 43.4086 1.13217 49.8448 4.60948C55.6993 7.71353 60.4247 12.5632 63.3645 18.4844L54.8703 25.1371L54.0804 23.6217C51.2588 18.2021 46.937 14.3825 41.1886 12.4195C31.9439 9.26467 21.442 12.6846 15.7518 20.6825C13.181 24.244 11.6727 28.4518 11.4023 32.817L11.3062 34.509L9.64661 34.8908C9.04666 35.0286 8.43871 35.159 7.84996 35.2865C7.64681 35.3301 7.44641 35.3733 7.24871 35.4162L0.90209 36.7934L0.897088 34.0331C0.866408 28.7647 2.09959 23.5563 4.49407 18.8413C4.77185 18.2957 5.09308 17.7255 5.38399 17.2096L5.79364 16.4736ZM62.2376 21.225C62.2036 21.1506 62.1715 21.076 62.1381 21.0027C62.0713 20.8514 62.0054 20.7021 61.936 20.5544C62.0069 20.7012 62.0713 20.8514 62.1381 21.0027C62.1717 21.0765 62.2039 21.1511 62.2378 21.2255L62.2376 21.225ZM6.78205 33.2254C6.98813 33.1806 7.19453 33.1359 7.4012 33.0915C7.98597 32.9656 8.57081 32.8395 9.15373 32.7055C9.44778 27.918 11.0992 23.3024 13.9161 19.3946C16.6093 15.6447 20.2986 12.7139 24.5656 10.9345C20.2986 12.7139 16.6096 15.6448 13.9164 19.3947C11.0994 23.3023 9.44777 27.918 9.15373 32.7055C8.57175 32.8392 7.98607 32.9659 7.40172 33.0915L7.39836 33.0933L6.78317 33.2265L6.78205 33.2254Z'
				fill={color}
			/>
			<path
				d='M4.496 41.1693C8.11583 39.1452 12.6778 40.4151 14.6855 44.0057C16.6932 47.5962 15.3863 52.1478 11.7664 54.1718C8.14661 56.1959 3.58462 54.926 1.57694 51.3354C-0.430736 47.7448 0.876174 43.1933 4.496 41.1693Z'
				fill={color}
			/>
		</svg>
	);
};

export default ArcWithDot;
